import { actions, isCurrentlyOnSecondaryTeam, loaders } from 'entities';

import { Button, Label, Skeleton } from 'components/Blocks';
import { CrownIcon } from 'components/Icons';

import { useAuth } from 'providers/Auth';

import { useLang } from 'hooks';
import { listGet } from 'utils/array';

export function SecondaryTeamSelect() {
  const { t } = useLang();

  const {
    user: { data: loggedUser },
    setLogin,
  } = useAuth();

  const [teams, teamsState] = loaders.teams.list.useV2({
    defaultValue: [],
  });

  const secondaryTeams = (loggedUser.secondaryTeams || [])
    .map((data) => ({
      ...data,
      team: listGet(teams, data.id)!,
    }))
    .filter((t) => t.team && t.id !== loggedUser.team.id);

  const assumeTeam = actions.auth.assumeTeam.use({
    onSuccess: setLogin,
  });

  if (!loggedUser.secondaryTeams?.length) return null;

  if (teamsState.errorOrLoading) return <Skeleton height={24} width="100%" />;

  const originalTeam = listGet(teams, loggedUser.originalTeam);

  return (
    <>
      <Label className="my-1.5 text-xs font-semibold">{t('secondary-teams')}</Label>

      {!!originalTeam && isCurrentlyOnSecondaryTeam(loggedUser) && (
        <Button
          variant="ghost"
          className="justify-start font-normal text-inherit hover:text-primary"
          onClick={() => assumeTeam.execute({ teamId: originalTeam.id })}
        >
          {originalTeam.name} <CrownIcon size={14} className="text-yellow-400" />
        </Button>
      )}

      {secondaryTeams.map((secondary) => (
        <Button
          key={secondary.id}
          variant="ghost"
          className="justify-start font-normal text-inherit hover:text-primary"
          onClick={() => assumeTeam.execute({ teamId: secondary.id })}
        >
          {secondary.team.name}
        </Button>
      ))}
    </>
  );
}
